import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL;
const envHost = new URL(envBase).hostname;
const { hostname, origin } = window.location;
const sameSite = hostname === envHost || hostname === "localhost" || hostname === "127.0.0.1";
export const BASE_URL = sameSite ? envBase : origin;
export const API = `${BASE_URL}/api`;
export const TOKEN_KEY = "roan_admin_token";

export const api = axios.create({ baseURL: API });
export const MEMBER_TOKEN_KEY = "roan_member_token";

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const mt = localStorage.getItem(MEMBER_TOKEN_KEY);
  if (mt) cfg.headers["X-Member-Token"] = mt;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const LOGO_URL = "/logo.png";
export const FB_URL = "https://www.facebook.com/share/g/1fR1KsqBum/?mibextid=wwXIfr";
export const GROUP_SIZE = 10;

export function fillColor(count) {
  if (!count) return "#D9E2EC";
  if (count <= 3) return "#9FB3C8";
  if (count <= 6) return "#8FA58A";
  if (count < 10) return "#E29578";
  if (count === 10) return "#E2705A";
  return "#B83B20";
}

export const PILLARS = [
  "Constitutional Correction",
  "Fix Radical Land Title",
  "People’s Initiative",
  "People’s Veto on Bills",
  "Bill of Rights entrenched",
  "End Single-Member Seats",
  "Federal Judicial Oversight",
  "Politician Audits",
  "Aussie Wealth Fund",
];
